import { Decimal } from 'decimal.js-light';

export const calcMaxDp = (dpmvString: string, pvString: string): string => {
    try {
        const dpmv = new Decimal(dpmvString);
        const pv = new Decimal(pvString);
        // dPV100 = Pv * dPMV / (1 - Pv)
        return pv.mul(dpmv).dividedBy(new Decimal(1).minus(pv)).toFixed(3);
    } catch {
        return '';
    }
};
